import styled from "styled-components";
export const Div = styled.nav`
    z-index:40;
    top:86px;

`;